import StoreStatsDaily from '@/entity/StatsStoreDaily';
import { addComma } from '@/utils/number';
/**
 * 상점 일별 통계 뷰모델
 */
export default class StoreStatsDailyVM extends StoreStatsDaily {
    // eslint-disable-next-line no-useless-constructor
    constructor(data) {
        super(data);
    }
    /**
     * 완료 건수
     */
    get allCountWithFormat() {
        return addComma(this.allCount);
    }
}
